import * as actions from './actions'
import mutations from './mutations'

let state = {
    items: [],
    total: 0
};

export default {mutations, actions, state}
